import React from "react";
import { Box, Container, Typography, Paper, Link } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GuideSection from "../Components/GuideSection";
import GuideContents from "../Components/GuideContents";
import ScrollTop from "../Components/ScrollTop";

function GuideHardcore() {
  return (
    <Box sx={{ flexGrow: 1, py: 4 }}>
      {/* Quick Navigation Table of Contents */}
      <Container sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, bgcolor: "#f8f8ff" }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <MenuBookIcon sx={{ fontSize: 36, mr: 2, color: "primary.main" }} />
            <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 0 }}>
              MCV Hardcore Introduction
            </Typography>
          </Box>

          <Typography variant="body1" paragraph>
            MCV Hardcore attempts to introduce balanced respawns into a "New
            Life" so you can continue to play with the community.
            <br />
            <br />
            It's an experimental game mode and there are plans to make deaths
            more punishing.
            <br />
            <br />
            Every player has access to free respawns. Usually 2 per 1000
            minecraft days.
            <br />
            <br />
            Respawn Tokens allow for immediate respawns. You can vote for or
            purchase them.
            <br />
            <br />
            The server is no-grief and PvP is optional. Do not steal from any
            player build at this time. Improvements to come.
            <br />
            <br />
            Protection Stones offer you a way to fully protect your builds.
            Every player has access to <code>/co inspect</code>
          </Typography>
          <br />
        </Paper>
      </Container>

      {/* Getting Started Guide */}
      <Container sx={{ mt: 4, mb: 4 }}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 3,
            }}
            id="getting-started"
          >
            <MenuBookIcon
              sx={{
                fontSize: 40,
                mr: 2,
                color: "primary.main",
              }}
            />
            <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 0 }}>
              MCV Hardcore Guide
            </Typography>
          </Box>

          <Typography
            variant="body1"
            paragraph
            sx={{
              backgroundColor: "rgba(33, 92, 156, 0.05)",
              p: 2,
              borderRadius: 2,
              border: "1px solid rgba(33, 92, 156, 0.1)",
              mb: 4,
            }}
          >
            To get started, join the server. Night time? Decide for yourself if
            you want to risk it or <code>/move lobby</code> to wait it out.
            <br />
            <br />
            More to come. See commands available in TAB menu in game.
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: 4,
              mb: 4,
              rowGap: 10,
            }}
          ></Box>
        </Paper>
      </Container>

      {/* Scroll to Top Button */}
      <ScrollTop />
    </Box>
  );
}

export default GuideHardcore;
